unit UReportItemForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, UWebReportUtils, WEBLib.ComCtrls, WEBLib.WebCtrls, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.Buttons, Vcl.Imaging.pngimage, UMainConfig,
  UWebSpeechRec;

type
  TReportItemForm = class(TForm)
    pnlTop: TPanel;
    lblBezeichnung: TLabel;
    edtBezeichnung: TEdit;
    pnlMain: TPanel;
    pcMain: TPageControl;
    tsHeading: TTabSheet;
    lblSize: TLabel;
    cbbSize: TComboBox;
    cbbAlign: TComboBox;
    lblAlign: TLabel;
    lblContent: TLabel;
    edtContent: TEdit;
    tsParagraph: TTabSheet;
    memParagraph: TMemo;
    pnlParagraphTop: TPanel;
    lblParagraph: TLabel;
    btnTake: TBitBtn;
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    btnMicOn: TBitBtn;
    btnMicOff: TBitBtn;
    procedure btnTakeClick(Sender: TObject);
    procedure pcMainChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure sgArtListCanEditCell(Sender: TObject; ACol, ARow: Integer;
      var CanEdit: Boolean);
    [Async]
    procedure WebFormResize(Sender: TObject); async;
    procedure btnBackClick(Sender: TObject);
    procedure btnMicOnClick(Sender: TObject);
    procedure btnMicOffClick(Sender: TObject);
    procedure tsParagraphShow(Sender: TObject);
    procedure tsHeadingShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
  private
    FItem: TReportItem;
    FFName: string;
    FMainConfig: TMainConfig;
    function CheckMask: Boolean;
    function GetMask: Boolean;
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure HandleSpeechRecCommand(Sender: TObject;
      SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
    procedure HandleSpeechRecNoResultMatch(Sender: TObject; Phrases: TStrings);
    procedure SetMask;
    procedure SetSubMask;
    procedure SetItem(const Value: TReportItem);
    procedure SetFName(const Value: string);
    procedure SetMainConfig(const Value: TMainConfig);
  public
    property Item: TReportItem read FItem write SetItem;
    property FName: string read FFName write SetFName;
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
  protected procedure LoadDFMValues; override; end;

var
  ReportItemForm: TReportItemForm;

implementation

uses
  WEBLib.LocalFiles, WEBLib.Utils, UEssentialHelper;

{$R *.dfm}

procedure TReportItemForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrNone;
  Self.Close;
end;

procedure TReportItemForm.btnMicOffClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Stopp;
end;

procedure TReportItemForm.btnMicOnClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.MainConfig.SpeechRec.Start;
end;

procedure TReportItemForm.btnTakeClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ModalResult := mrNone;
  if Self.CheckMask and Self.GetMask then
    Self.ModalResult := mrOK;
end;

function TReportItemForm.CheckMask: Boolean;
var
  error: string;
begin
  error := '';
  if (error = '') and (edtBezeichnung.Text = '') then
  begin
    error := 'Bezeichnung darf nicht leer sein!';
    edtBezeichnung.SetFocus;
  end;
  if pcMain.ActivePageIndex = 0 then
  begin
    if (error = '') and (edtContent.Text = '') then
    begin
      error := 'Text darf nicht leer sein!';
      edtContent.SetFocus;
    end;
  end;
  if pcMain.ActivePageIndex = 1 then
  begin
    if (error = '') and (memParagraph.Lines.Text = '') then
    begin
      error := 'Text darf nicht leer sein!';
      memParagraph.SetFocus;
    end;
  end;
  if error <> '' then
    MessageDLG(error, mtWarning, [mbOK], nil);
  Result := error = '';
end;

function TReportItemForm.GetMask: Boolean;
begin
  Result := true;
  Self.Item.Kind := TReportItemKind(pcMain.ActivePageIndex + 1);
  Self.Item.Bezeichnung := edtBezeichnung.Text;
  case Self.Item.Kind of
    ikUnknown:
      ;
    ikHeading:
      begin
        if not(Self.Item.SubItem is TReportHeading) then
          Self.Item.SubItem := TReportHeading.Create;
        with Self.Item.SubItem as TReportHeading do
        begin
          Size := cbbSize.Text;
          Align := cbbAlign.Text;
          Content := edtContent.Text;
        end;
      end;
    ikParagraph:
      begin
        if not(Self.Item.SubItem is TReportParagraph) then
          Self.Item.SubItem := TReportParagraph.Create;
        with Self.Item.SubItem as TReportParagraph do
        begin
          Content.Text := memParagraph.Lines.Text;
        end;
      end;
    ikImage:
      ;
    ikArtList:
      ;
  end;
end;

procedure TReportItemForm.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if PropertyName = 'Active' then
  begin
    btnMicOn.Visible := not Self.MainConfig.SpeechRec.Active;
    btnMicOff.Visible := Self.MainConfig.SpeechRec.Active;
  end;
end;

procedure TReportItemForm.HandleSpeechRecCommand(Sender: TObject;
  SpeechRecCommand: TSpeechRecCommand; Parameters: TStrings);
var
  s: string;
  i: Integer;
begin
  case SpeechRecCommand of
    srcAll:
      memParagraph.Clear;
    srcLast:
      begin
        if memParagraph.Lines.Count > 0 then
          memParagraph.Lines.Delete(memParagraph.Lines.Count - 1);
      end;
    srcNumber:
      begin
        s := Parameters[0];
        if TryStrToInt(s, i) then
        begin
          Dec(i);
          if (0 <= i) and (i < memParagraph.Lines.Count) then
            memParagraph.Lines.Delete(i);
        end;
      end;
  end;
end;

procedure TReportItemForm.HandleSpeechRecNoResultMatch(Sender: TObject;
  Phrases: TStrings);
var
  s, t: string;
begin
  s := Phrases[0];
  s := Trim(s);
  if s <> '' then
  begin
    t := s[1];
    t := UpperCase(t);
    Delete(s, 1, 1);
    s := t + s;
    t := Copy(s, Length(s) - 5, 6);
    t := LowerCase(t);
    if t = ' punkt' then
    begin
      Delete(s, Length(s) - 5, 6);
      s := s + '.';
    end;
    s := StringReplace(s, ' Komma', ',', [rfReplaceAll]);
    s := StringReplace(s, 'Strich', '-', [rfReplaceAll]);
    s := StringReplace(s, ' Fragezeichen', '?', [rfReplaceAll]);
    s := StringReplace(s, ' Ausrufezeichen', '!', [rfReplaceAll]);
    s := StringReplace(s, ' Doppelpunkt', ':', [rfReplaceAll]);
    s := StringReplace(s, ' Semikolon', ';', [rfReplaceAll]);
    if s[Length(s)] <> '.' then
      s := s + '.';
    memParagraph.Lines.Add(s);
  end;
end;

procedure TReportItemForm.pcMainChange(Sender: TObject);
begin
  Self.Item.Kind := TReportItemKind(pcMain.TabIndex + 1);
  Self.SetSubMask;
end;

procedure TReportItemForm.SetFName(const Value: string);
begin
  FFName := Value;
end;

procedure TReportItemForm.SetItem(const Value: TReportItem);
begin
  FItem := Value;
  Self.SetMask;
end;

procedure TReportItemForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch :=
    Self.HandleSpeechRecNoResultMatch;
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := Self.HandleSpeechRecCommand;
  Self.MainConfig.SpeechRec.OnpropertyChanged := Self.HandlePropertyChanged;
  Self.HandlePropertyChanged(Self, 'Active');
end;

procedure TReportItemForm.SetMask;
begin
  edtBezeichnung.Text := Self.Item.Bezeichnung;
  Self.SetSubMask;
end;

procedure TReportItemForm.SetSubMask;
var
  i: Integer;
begin
  if Self.Item.Kind = ikUnknown then
    Self.Item.Kind := ikHeading;
  i := Integer(Self.Item.Kind) - 1;
  if i < 0 then
    i := 0;
  pcMain.TabIndex := i;
  case Self.Item.Kind of
    ikUnknown:
      ;
    ikHeading:
      begin
        if not(Self.Item.SubItem is TReportHeading) then
          Self.Item.SubItem := TReportHeading.Create;
        with (Self.Item.SubItem as TReportHeading) do
        begin
          i := cbbSize.Items.IndexOf(Size);
          if i >= 0 then
            cbbSize.ItemIndex := i
          else
            cbbSize.ItemIndex := 0;
          i := cbbAlign.Items.IndexOf(Align);
          if i >= 0 then
            cbbAlign.ItemIndex := i
          else
            cbbAlign.ItemIndex := 0;
          edtContent.Text := Content;
        end;
      end;
    ikParagraph:
      begin
        if not(Self.Item.SubItem is TReportParagraph) then
          Self.Item.SubItem := TReportParagraph.Create;
        with (Self.Item.SubItem as TReportParagraph) do
        begin
          memParagraph.Lines.Text := Content.Text;
        end;
      end;
    ikImage:
      ;
    ikArtList:
      ;
  end;
end;

procedure TReportItemForm.sgArtListCanEditCell(Sender: TObject;
  ACol, ARow: Integer; var CanEdit: Boolean);
begin
  CanEdit := true;
  if (ACol = 0) or (ACol = 3) then
    CanEdit := false;
end;

procedure TReportItemForm.tsHeadingShow(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TReportItemForm.tsParagraphShow(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TReportItemForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  if Self.MainConfig.SpeechRec.Active then
    Self.MainConfig.SpeechRec.Stopp;
  Self.MainConfig.SpeechRec.OnSpeechRecNoResultMatch := nil;
  Self.MainConfig.SpeechRec.OnSpeechRecCommand := nil;
  Self.MainConfig.SpeechRec.OnpropertyChanged := nil;
end;

procedure TReportItemForm.WebFormCreate(Sender: TObject);
begin
  Self.FName := '';
end;

procedure TReportItemForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Berichtsteil';
    btnTake.Top := Self.ClientHeight - btnTake.Height - pnlTop.Height - 48;
    btnMicOn.Top := btnTake.Top - pnlParagraphTop.Height + 8;
    btnMicOff.Top := btnMicOn.Top;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Berichtsteil';
    btnTake.Top := Self.ClientHeight - (2 * pnlFooter.Height) - btnTake.Height -
      pnlTop.Height - 48;
    btnMicOn.Top := btnTake.Top - pnlParagraphTop.Height + 8;
    btnMicOff.Top := btnMicOn.Top;

  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  btnTake.Left := Self.ClientWidth - btnTake.Width - 24;
  btnMicOn.Left := 16;
  btnMicOff.Left := btnMicOn.Left;
end;

procedure TReportItemForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlTop := TPanel.Create(Self);
  lblBezeichnung := TLabel.Create(Self);
  edtBezeichnung := TEdit.Create(Self);
  pnlMain := TPanel.Create(Self);
  pcMain := TPageControl.Create(Self);
  tsHeading := TTabSheet.Create(Self);
  lblSize := TLabel.Create(Self);
  lblAlign := TLabel.Create(Self);
  lblContent := TLabel.Create(Self);
  cbbSize := TComboBox.Create(Self);
  cbbAlign := TComboBox.Create(Self);
  edtContent := TEdit.Create(Self);
  tsParagraph := TTabSheet.Create(Self);
  memParagraph := TMemo.Create(Self);
  pnlParagraphTop := TPanel.Create(Self);
  lblParagraph := TLabel.Create(Self);
  btnMicOn := TBitBtn.Create(Self);
  btnMicOff := TBitBtn.Create(Self);
  btnTake := TBitBtn.Create(Self);
  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);

  pnlTop.BeforeLoadDFMValues;
  lblBezeichnung.BeforeLoadDFMValues;
  edtBezeichnung.BeforeLoadDFMValues;
  pnlMain.BeforeLoadDFMValues;
  pcMain.BeforeLoadDFMValues;
  tsHeading.BeforeLoadDFMValues;
  lblSize.BeforeLoadDFMValues;
  lblAlign.BeforeLoadDFMValues;
  lblContent.BeforeLoadDFMValues;
  cbbSize.BeforeLoadDFMValues;
  cbbAlign.BeforeLoadDFMValues;
  edtContent.BeforeLoadDFMValues;
  tsParagraph.BeforeLoadDFMValues;
  memParagraph.BeforeLoadDFMValues;
  pnlParagraphTop.BeforeLoadDFMValues;
  lblParagraph.BeforeLoadDFMValues;
  btnMicOn.BeforeLoadDFMValues;
  btnMicOff.BeforeLoadDFMValues;
  btnTake.BeforeLoadDFMValues;
  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  try
    Name := 'ReportItemForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlTop.SetParentComponent(Self);
    pnlTop.Name := 'pnlTop';
    pnlTop.Left := 0;
    pnlTop.Top := 64;
    pnlTop.Width := 640;
    pnlTop.Height := 57;
    pnlTop.Align := alTop;
    pnlTop.Caption := 'pnlTop';
    pnlTop.ChildOrder := 1;
    pnlTop.ShowCaption := False;
    lblBezeichnung.SetParentComponent(pnlTop);
    lblBezeichnung.Name := 'lblBezeichnung';
    lblBezeichnung.Left := 8;
    lblBezeichnung.Top := 8;
    lblBezeichnung.Width := 68;
    lblBezeichnung.Height := 15;
    lblBezeichnung.Caption := 'Bezeichnung';
    lblBezeichnung.HeightPercent := 100.000000000000000000;
    lblBezeichnung.WidthPercent := 100.000000000000000000;
    edtBezeichnung.SetParentComponent(pnlTop);
    edtBezeichnung.Name := 'edtBezeichnung';
    edtBezeichnung.Left := 8;
    edtBezeichnung.Top := 27;
    edtBezeichnung.Width := 200;
    edtBezeichnung.Height := 22;
    edtBezeichnung.ChildOrder := 3;
    edtBezeichnung.HeightPercent := 100.000000000000000000;
    edtBezeichnung.Text := 'edtBezeichnung';
    edtBezeichnung.WidthPercent := 100.000000000000000000;
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 0;
    pnlMain.Top := 121;
    pnlMain.Width := 640;
    pnlMain.Height := 335;
    pnlMain.Align := alClient;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 2;
    pnlMain.ShowCaption := False;
    pcMain.SetParentComponent(pnlMain);
    pcMain.Name := 'pcMain';
    pcMain.Left := 0;
    pcMain.Top := 0;
    pcMain.Width := 640;
    pcMain.Height := 335;
    pcMain.Align := alClient;
    pcMain.TabIndex := 0;
    pcMain.TabOrder := 0;
    SetEvent(pcMain, Self, 'OnChange', 'pcMainChange');
    tsHeading.SetParentComponent(pcMain);
    tsHeading.Name := 'tsHeading';
    tsHeading.Left := 0;
    tsHeading.Top := 20;
    tsHeading.Width := 640;
    tsHeading.Height := 315;
    tsHeading.Caption := #220'berschrift';
    SetEvent(tsHeading, Self, 'OnShow', 'tsHeadingShow');
    lblSize.SetParentComponent(tsHeading);
    lblSize.Name := 'lblSize';
    lblSize.Left := 8;
    lblSize.Top := 8;
    lblSize.Width := 32;
    lblSize.Height := 15;
    lblSize.Caption := 'Gr'#246#223'e';
    lblSize.HeightPercent := 100.000000000000000000;
    lblSize.WidthPercent := 100.000000000000000000;
    lblAlign.SetParentComponent(tsHeading);
    lblAlign.Name := 'lblAlign';
    lblAlign.Left := 8;
    lblAlign.Top := 58;
    lblAlign.Width := 65;
    lblAlign.Height := 15;
    lblAlign.Caption := 'Ausrichtung';
    lblAlign.HeightPercent := 100.000000000000000000;
    lblAlign.WidthPercent := 100.000000000000000000;
    lblContent.SetParentComponent(tsHeading);
    lblContent.Name := 'lblContent';
    lblContent.Left := 8;
    lblContent.Top := 108;
    lblContent.Width := 21;
    lblContent.Height := 15;
    lblContent.Caption := 'Text';
    lblContent.HeightPercent := 100.000000000000000000;
    lblContent.WidthPercent := 100.000000000000000000;
    cbbSize.SetParentComponent(tsHeading);
    cbbSize.Name := 'cbbSize';
    cbbSize.Left := 8;
    cbbSize.Top := 27;
    cbbSize.Width := 60;
    cbbSize.Height := 23;
    cbbSize.HeightPercent := 100.000000000000000000;
    cbbSize.Text := '5';
    cbbSize.WidthPercent := 100.000000000000000000;
    cbbSize.ItemIndex := 4;
    cbbSize.Items.BeginUpdate;
    try
      cbbSize.Items.Clear;
      cbbSize.Items.Add('1');
      cbbSize.Items.Add('2');
      cbbSize.Items.Add('3');
      cbbSize.Items.Add('4');
      cbbSize.Items.Add('5');
    finally
      cbbSize.Items.EndUpdate;
    end;
    cbbAlign.SetParentComponent(tsHeading);
    cbbAlign.Name := 'cbbAlign';
    cbbAlign.Left := 8;
    cbbAlign.Top := 77;
    cbbAlign.Width := 200;
    cbbAlign.Height := 23;
    cbbAlign.HeightPercent := 100.000000000000000000;
    cbbAlign.Text := 'zentriert';
    cbbAlign.WidthPercent := 100.000000000000000000;
    cbbAlign.ItemIndex := 2;
    cbbAlign.Items.BeginUpdate;
    try
      cbbAlign.Items.Clear;
      cbbAlign.Items.Add('links');
      cbbAlign.Items.Add('rechts');
      cbbAlign.Items.Add('zentriert');
    finally
      cbbAlign.Items.EndUpdate;
    end;
    edtContent.SetParentComponent(tsHeading);
    edtContent.Name := 'edtContent';
    edtContent.Left := 8;
    edtContent.Top := 127;
    edtContent.Width := 200;
    edtContent.Height := 22;
    edtContent.ChildOrder := 5;
    edtContent.HeightPercent := 100.000000000000000000;
    edtContent.Text := 'edtContent';
    edtContent.WidthPercent := 100.000000000000000000;
    tsParagraph.SetParentComponent(pcMain);
    tsParagraph.Name := 'tsParagraph';
    tsParagraph.Left := 0;
    tsParagraph.Top := 20;
    tsParagraph.Width := 640;
    tsParagraph.Height := 315;
    tsParagraph.Caption := 'Absatz';
    tsParagraph.ChildOrder := 1;
    SetEvent(tsParagraph, Self, 'OnShow', 'tsParagraphShow');
    memParagraph.SetParentComponent(tsParagraph);
    memParagraph.Name := 'memParagraph';
    memParagraph.Left := 0;
    memParagraph.Top := 27;
    memParagraph.Width := 640;
    memParagraph.Height := 288;
    memParagraph.Align := alClient;
    memParagraph.Font.Charset := DEFAULT_CHARSET;
    memParagraph.Font.Color := clWindowText;
    memParagraph.Font.Height := -16;
    memParagraph.Font.Name := 'Segoe UI';
    memParagraph.Font.Style := [];
    memParagraph.HeightPercent := 100.000000000000000000;
    memParagraph.Lines.BeginUpdate;
    try
      memParagraph.Lines.Clear;
      memParagraph.Lines.Add('memParagraph');
    finally
      memParagraph.Lines.EndUpdate;
    end;
    memParagraph.ParentFont := False;
    memParagraph.SelLength := 0;
    memParagraph.SelStart := 0;
    memParagraph.WidthPercent := 100.000000000000000000;
    pnlParagraphTop.SetParentComponent(tsParagraph);
    pnlParagraphTop.Name := 'pnlParagraphTop';
    pnlParagraphTop.Left := 0;
    pnlParagraphTop.Top := 0;
    pnlParagraphTop.Width := 640;
    pnlParagraphTop.Height := 27;
    pnlParagraphTop.Align := alTop;
    pnlParagraphTop.Caption := 'pnlParagraphTop';
    pnlParagraphTop.ChildOrder := 2;
    pnlParagraphTop.ShowCaption := False;
    lblParagraph.SetParentComponent(pnlParagraphTop);
    lblParagraph.Name := 'lblParagraph';
    lblParagraph.Left := 8;
    lblParagraph.Top := 8;
    lblParagraph.Width := 21;
    lblParagraph.Height := 15;
    lblParagraph.Caption := 'Text';
    lblParagraph.HeightPercent := 100.000000000000000000;
    lblParagraph.WidthPercent := 100.000000000000000000;
    btnMicOn.SetParentComponent(tsParagraph);
    btnMicOn.Name := 'btnMicOn';
    btnMicOn.Left := 24;
    btnMicOn.Top := 240;
    btnMicOn.Width := 40;
    btnMicOn.Height := 40;
    btnMicOn.Hint := 'Spracherkennung einschalten';
    btnMicOn.Color := clNone;
    btnMicOn.ElementClassName := 'btnMicro';
    btnMicOn.Glyph.LoadFromFile('UReportItemForm.tsParagraph.btnMicOn.Glyph.png');
    btnMicOn.GlyphSize := 32;
    btnMicOn.HeightPercent := 100.000000000000000000;
    btnMicOn.ShowHint := True;
    btnMicOn.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOn, Self, 'OnClick', 'btnMicOnClick');
    btnMicOff.SetParentComponent(tsParagraph);
    btnMicOff.Name := 'btnMicOff';
    btnMicOff.Left := 32;
    btnMicOff.Top := 248;
    btnMicOff.Width := 40;
    btnMicOff.Height := 40;
    btnMicOff.Hint := 'Spracherkennung ausschalten';
    btnMicOff.Color := clNone;
    btnMicOff.ElementClassName := 'btnMicro';
    btnMicOff.Glyph.LoadFromFile('UReportItemForm.tsParagraph.btnMicOff.Glyph.png');
    btnMicOff.GlyphSize := 32;
    btnMicOff.HeightPercent := 100.000000000000000000;
    btnMicOff.ShowHint := True;
    btnMicOff.WidthPercent := 100.000000000000000000;
    SetEvent(btnMicOff, Self, 'OnClick', 'btnMicOffClick');
    btnTake.SetParentComponent(pnlMain);
    btnTake.Name := 'btnTake';
    btnTake.Left := 555;
    btnTake.Top := 200;
    btnTake.Width := 40;
    btnTake.Height := 40;
    btnTake.Hint := #220'bernehmen';
    btnTake.Color := clNone;
    btnTake.ElementClassName := 'btnMicro';
    btnTake.Glyph.LoadFromFile('UReportItemForm.pnlMain.btnTake.Glyph.png');
    btnTake.GlyphSize := 32;
    btnTake.HeightPercent := 100.000000000000000000;
    btnTake.ShowHint := True;
    btnTake.WidthPercent := 100.000000000000000000;
    SetEvent(btnTake, Self, 'OnClick', 'btnTakeClick');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UReportItemForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Berichtsteil';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UReportItemForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
  finally
    pnlTop.AfterLoadDFMValues;
    lblBezeichnung.AfterLoadDFMValues;
    edtBezeichnung.AfterLoadDFMValues;
    pnlMain.AfterLoadDFMValues;
    pcMain.AfterLoadDFMValues;
    tsHeading.AfterLoadDFMValues;
    lblSize.AfterLoadDFMValues;
    lblAlign.AfterLoadDFMValues;
    lblContent.AfterLoadDFMValues;
    cbbSize.AfterLoadDFMValues;
    cbbAlign.AfterLoadDFMValues;
    edtContent.AfterLoadDFMValues;
    tsParagraph.AfterLoadDFMValues;
    memParagraph.AfterLoadDFMValues;
    pnlParagraphTop.AfterLoadDFMValues;
    lblParagraph.AfterLoadDFMValues;
    btnMicOn.AfterLoadDFMValues;
    btnMicOff.AfterLoadDFMValues;
    btnTake.AfterLoadDFMValues;
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
  end;
end;

end.
